import {
  AmagiNowLogo,
  AmagiNowLogoOrange,
  cssVar,
  makeStyles,
} from '@amagimedia/amagi-design-system';
import { Typography } from '@amagimedia/amagi-design-system/src/Typography/Typography';
import { CheckCircleOutlineIcon } from '@amagimedia/amagi-design-system/src/icons/CheckCircleOutlineIcon';
import type { FC } from 'react';
import AmagiNowBackgroundImage from '../assets/amaginow-bg-new.jpg';

export const useStyles = makeStyles({
  homeScreenContainer: {
    height: '100vh',
    backgroundImage: `url(${AmagiNowBackgroundImage})`,
    backgroundSize: 'cover',
  },
  mainContainer: {
    display: 'flex',
    alignItems: 'center',
    margin: 'auto',
    height: 'calc(100% - 140px)',
    maxWidth: '1365px',
    paddingBottom: '10%',
  },
  contentContainer: {
    width: '543px',
    height: '454px',
    padding: '101px 89px 126px 90px',
    borderRadius: '24px',
    marginRight: '69px',
    opacity: 0.9,
    background: cssVar('--neutrals-grey-1000'),
  },
  titleContainer: {
    marginBottom: '64px',
    height: '38px',
    width: '251px',
  },
  productTitle: {
    color: cssVar('--primary-color'),
    marginLeft: '5px',
  },
  caption: {
    display: 'flex',
    flexDirection: 'column',
    gap: '24px',
    width: '462px',
    color: cssVar('--field-value-color'),
    marginLeft: '62px',
    marginRight: 'auto',
  },
  listElementContainer: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
    gap: '8px',
  },
  checkBoxElement: {
    fill: cssVar('--field-value-color'),
    width: '25px',
    height: '25px',
  },
  checkBoxElementWrapper: {
    display: 'flex',
    alignItems: 'center',
    gap: '6px',
  },
  amagiNow: {
    margin: '55px 62px',
  },
});

export const HomeScreenContainer: FC = (props) => {
  const classes = useStyles();

  function renderContent() {
    return (
      <div className={classes.contentContainer}>
        <AmagiNowLogoOrange className={classes.titleContainer} />
        {props.children}
      </div>
    );
  }

  return (
    <div className={classes.homeScreenContainer}>
      <AmagiNowLogo className={classes.amagiNow} />
      <div className={classes.mainContainer}>
        <div className={classes.caption}>
          <Typography type="headingH1" id="signin-heading">
            Amagi’s FAST Platform to easily manage content, distribution and
            monetisation
          </Typography>
          <div className={classes.listElementContainer}>
            <div className={classes.checkBoxElementWrapper}>
              <CheckCircleOutlineIcon className={classes.checkBoxElement} />
              <Typography type="headingH3">Enhanced Efficiency</Typography>
            </div>
            <div className={classes.checkBoxElementWrapper}>
              <CheckCircleOutlineIcon className={classes.checkBoxElement} />
              <Typography type="headingH3">Effortless Control</Typography>
            </div>
            <div className={classes.checkBoxElementWrapper}>
              <CheckCircleOutlineIcon className={classes.checkBoxElement} />
              <Typography type="headingH3">Actionable Data</Typography>
            </div>
            <div className={classes.checkBoxElementWrapper}>
              <CheckCircleOutlineIcon className={classes.checkBoxElement} />
              <Typography type="headingH3">Optimised Distribution</Typography>
            </div>
          </div>
        </div>
        {renderContent()}
      </div>
    </div>
  );
};
